import { useCallback, useEffect, useState, useRef } from 'react';

export const useIsScrolling = (timeout = 100) => {
    const [isScrolling, setIsScrolling] = useState(false);
    const timeoutRef = useRef(null);

    const onScroll = useCallback(() => {
        clearTimeout(timeoutRef.current);
        setIsScrolling(true);
        timeoutRef.current = setTimeout(() => {
            setIsScrolling(false);
        }, timeout);
    }, [timeout]);

    useEffect(() => {
        if (timeout) {
            document.addEventListener('scroll', onScroll);
        }
        return () => {
            document.removeEventListener('scroll', onScroll);
        };
    }, [onScroll, timeout]);

    return isScrolling;
};
